
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/timeline/templates/layout"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class='timeline_wrapper'></div>\n";
},"useData":true});
    }).call(this);
  